import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { CoreLink } from '@uncinc/react-drupal-core';
import { Highlight } from 'react-instantsearch';
import { Image } from '@uncinc/uncinc-react-kitchen-sink';
import SearchTag from '../../Atoms/SearchTag';
import { removeImageStyleFromSvgUrl } from '../../../helpers';

const SearchKitResult = (props) => {
  const { hit } = props;

  const type = hit.type[0];
  const combinedTypes = hit.combined_types?.[0];
  const classNames = c('SearchAllContent__Results__Hit');
  const { t, i18n } = useTranslation();
  const imageUrl = removeImageStyleFromSvgUrl(hit.image_style_uri?.[0]);
  const tagText = i18n.exists(`tags.${type.toLowerCase()}`)
    ? t(`tags.${type.toLowerCase()}`)
    : type;

  return (
    <article className={classNames}>
      <div className="SearchAllContent__Results__Hit__content">
        {hit.type && (
          <SearchTag
            className=""
            text={combinedTypes ?? tagText}
            type={type}
          />
        )}

        <h4>
          <CoreLink className="teaser-link" to={hit.url[0]}>
            <Highlight attribute="title" hit={hit} />
          </CoreLink>
        </h4>

        <p className={`mb-0 u-word-break ${hit.image_style_uri ? 'u-truncate--3' : 'u-truncate--2'}`}>
          {hit.description ? (
            <Highlight attribute="description" hit={hit} />
          ) :
            <Highlight attribute="summary" hit={hit} /> }
        </p>
      </div>

      <div className="SearchAllContent__Results__Hit__image">
        {imageUrl && (
          <Image src={imageUrl} alt="" />
        )}
      </div>
    </article>
  );
};

export default SearchKitResult;
